import { observer } from "mobx-react-lite";
import { useSearchStore } from "../..";
import styles from './Search.module.css';
import SearchLine from "./SearchLine";
import SearchPanel from "./SearchPanel";

function Search() {
    const searchStore = useSearchStore();

    return (
        <div className={searchStore.isOpen ? styles.openedContainer : styles.container}>
            <SearchLine />
            {searchStore.isOpen && (
                <SearchPanel />
            )}
        </div>
    );
}

export default observer(Search);